var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(!_setup.props.licenseId)?_c('p',[_c('i',[_vm._v("Workflow does not define a license.")])]):_c(_setup.License,{attrs:{"license-id":_setup.props.licenseId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }